import React from 'react'
import { Link } from 'react-router-dom'

export default ({ handleNavClick, pages, trips }) => (
  <nav className="menu">
    <div className="container">
      <ul className="menu__items">
        {trips.map(trip => (
          <li key={trip.id} className="menu__item">
            <Link to={{
              pathname: `/${trip.slug}`,
              state: {
                to: 'trip'
              }
            }} onClick={() => handleNavClick()}>{trip.title.rendered}</Link>
          </li>
        ))}
      </ul>

      <div className="menu__links">
        {
          pages.map(page => <Link key={page.id} to={{
            pathname: `/${page.slug}`,
            state: {
              to: 'page'
            }
          }} onClick={() => handleNavClick()}>{page.title.rendered}</Link>)
        }
      </div>
    </div>
  </nav>
)


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js